import { useCallback, useEffect, useState } from 'react';
import { getPopularReportsApi } from '@intelligence/services/reportService';
import type { IntelligenceReportDataInfo } from '../types';
import { REPORT_SEARCH_SYSTEMS } from '../_constants';
import { createReportFieldUpdater } from './helpers';
import type { ISearchResponse } from './types';

export const usePopularReports = () => {
  const [reports, setReports] = useState<IntelligenceReportDataInfo[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getPopularReportsApi({ systems: REPORT_SEARCH_SYSTEMS })
      .then((res: ISearchResponse) => {
        if (cancelled) return;
        const list: IntelligenceReportDataInfo[] = Array.isArray(res?.resource_list)
          ? res.resource_list
          : [];
        setReports(list);
      })
      .catch((err: unknown) => {
        console.error('[ReportSearch] fetch popular reports failed:', err);
        if (!cancelled) setReports([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const updateReportField = useCallback(createReportFieldUpdater(setReports), []);

  return { reports, loading, updateReportField };
};
